import React from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl"
import Stack from "@mui/material/Stack";
import { useAddTagsMutation } from "services/tag/tagApi";
import { FormProvider, useForm, Controller } from "react-hook-form";
import { TextField } from "@mui/material";
import { useTheme } from "@mui/material";

const TagUploader = () => {
  const theme = useTheme();
  const methods = useForm();
  const useBulkUpload = React.useState<boolean>(true); // When this is properly implemented, false will be the default state

  const [uploadTags, { data, isLoading }] = useAddTagsMutation();

  const onSubmit = (data: any) => {
    if (useBulkUpload) {
      console.log(JSON.stringify(JSON.parse(data.bulkStr)));
      uploadTags({ useBulkUpload, ...data, bulkStr: data.bulkStr });
    }
  };

  return (
    <Box m={2}>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <Button type="submit" variant="contained">
            Submit
          </Button>
          <Stack spacing={2} marginTop={2}>
            <FormControl>
              <Controller
                control={methods.control}
                name='bulkStr'
                render={() => (
                  <TextField
                    minRows={32}
                    multiline
                    sx={{
                      ".MuiInputBase-root": {
                        backgroundColor: theme.palette.background.paper,
                      },
                    }}
                    {...methods.register("bulkStr")}
                  />
                )}
              />
            </FormControl>
          </Stack>
        </form>
      </FormProvider>
    </Box>
  );
};

export default TagUploader;
